module.exports = __webpack_public_path__ + "images/avatars/male/9.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/9.svg
// module id = 8IAX
// module chunks = 118